import type {PayloadAction} from '@reduxjs/toolkit';
import { createSlice} from '@reduxjs/toolkit';

import ProactLogo from 'src/Assets/images/Proact_Logo.png';

export interface InterfaceState {
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  isSidebarClosing: boolean;
  isSidebarOpen: boolean;
  isSidebarCollapsed: boolean;
  logoUrl: string;
  isHeadlessMode: boolean;
}

// Initial state
const initialState: InterfaceState = {
  isError: false,
  isSuccess: false,
  isLoading: false,
  isSidebarClosing: false,
  isSidebarOpen: false,
  isSidebarCollapsed: false,
  logoUrl: ProactLogo,
  isHeadlessMode: false,
};

// Slice
export const interfaceSlice = createSlice({
  name: 'interface',
  initialState,
  reducers: {
    resetInterfaceState: () => initialState,
    setIsSidebarClosing: (state, action: PayloadAction<boolean>) => {
      state.isSidebarClosing = action.payload;
    },
    setIsSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isSidebarOpen = action.payload;
    },
    setIsSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isSidebarCollapsed = action.payload;
    },
    resetLogoUrl: state => {
      state.logoUrl = ProactLogo;
    },
    setLogoUrl: (state, action: PayloadAction<string>) => {
      state.logoUrl = action.payload;
    },
    setIsHeadlessMode: (state, action: PayloadAction<boolean>) => {
      state.isHeadlessMode = action.payload;
    },
  },
});

export const {
  resetInterfaceState,
  setIsSidebarOpen,
  setIsSidebarClosing,
  setIsSidebarCollapsed,
  setLogoUrl,
  resetLogoUrl,
  setIsHeadlessMode,
} = interfaceSlice.actions;

export default interfaceSlice.reducer;
